function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledSocialProofComponent } from "./social-proof-component.scss";
import CompaniesLogosComponent from "components/segments/companies-logos/companies-logos-component";
import ReviewsComponent from "components/segments/reviews/reviews-component";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
class SocialProofComponent extends PureComponent {
    render() {
        const { CompaniesLogos, Reviews, Signup } = this.props;
        return /*#__PURE__*/ _jsxs(StyledSocialProofComponent, {
            className: "social-proof-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "companies-logos-component-wrapper",
                    children: /*#__PURE__*/ _jsx(CompaniesLogosComponent, _object_spread({}, CompaniesLogos))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "reviews-component-wrapper",
                    children: /*#__PURE__*/ _jsx(ReviewsComponent, _object_spread({}, Reviews))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "signup-with-decorations-component-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, _object_spread({}, Signup))
                })
            ]
        });
    }
}
export { SocialProofComponent as default };
SocialProofComponent.defaultProps = {
    CompaniesLogos: {
        paragraph: {},
        showSignup: false
    },
    Reviews: {
        columnWidth: "350px",
        reviews: [
            {
                reviewContent: [
                    '"I\'ve tried... Asana, Trello, Smartsheet... I was using a combination of 3 or so at a time to accomplish everything I needed. There was a huge sigh of relief when I found monday.com."'
                ],
                reviewerName: "Dotan Egozi, monday.com"
            },
            {
                reviewContent: [
                    '"I\'ve tried... Asana, Trello, Smartsheet... I was using a combination of 3 or so at a time to accomplish everything I needed. There was a huge sigh of relief when I found monday.com."'
                ],
                reviewerName: "Dotan Egozi, monday.com"
            }
        ]
    },
    Signup: {}
};
